export default __webpack_public_path__ + "static/media/03b6008b189bc325bcb00c8dc69700ea.068e5012.svg";